import { render, staticRenderFns } from "./RedditPoll.vue?vue&type=template&id=d0ff78e4"
import script from "./RedditPoll.vue?vue&type=script&lang=js"
export * from "./RedditPoll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports